/**
 * Centralized error message extraction utility.
 * Replaces the repeated pattern:
 *   err instanceof Error ? err.message : 'Fallback message'
 */

/**
 * Extract a user-facing message from an unknown error value.
 * @param err - The caught error (may be Error, string, or unknown)
 * @param fallback - Default message when the error type is unrecognised
 */
export function getErrorMessage(err: unknown, fallback: string): string {
  if (err instanceof Error) return err.message;
  if (typeof err === 'string') return err;
  return fallback;
}
